import { css } from 'linaria';
import { styled } from 'linaria/react';
import { breakpoints } from '../../../../../../media';

export const modalCloseButtonStyles = css`
	& > div > button {
		width: 32px !important;
		height: 32px !important;
		background-color: var(--control-primary);

		&:hover {
			background-color: var(--control-hover-primary);
		}

		& > span > div > svg {
			width: 20px !important;
			height: 20px !important;
			color: var(--text-invert);
		}
	}
`;
export const modalFooterStyles = css`
	${breakpoints.only.smMobile} {
		margin-top: 16px;
		margin-bottom: 16px;
	}
`;
export const ModalInner = styled.div`
	display: grid;
	grid-template-columns: 448px 576px;
	background-color: var(--background-secondary);
`;
export const ModalInfo = styled.div`
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	height: 428px;
	padding: 32px;
`;
export const ModalPhoto = styled.img`
	width: 100%;
	height: 428px;
	object-fit: cover;

	${breakpoints.to.desktop} {
		display: none;
	}
`;
export const ModalDescription = styled.div`
	margin-top: 16px;
`;
export const ModalButtons = styled.div`
	margin-top: auto;
`;
export const modalContentItemStyles = css`
	& + & {
		margin-top: 16px;
	}
`;
export const modalTitleStyles = css`
	${breakpoints.only.smMobile} {
		display: none;
	}
`;
export const modalMobileTitleStyles = css`
	padding: 24px 16px 16px;

	${breakpoints.from.mobile} {
		display: none;
	}
`;
export const CurtainsKindsSection = styled.section`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-template-rows: repeat(2, 1fr);
	width: 100%;
	padding: 32px 40px;
	margin-top: 80px;
	column-gap: 24px;
	row-gap: 16px;
	background-color: var(--background-secondary);
	border-radius: 8px;

	${breakpoints.only.desktop} {
		grid-template-columns: repeat(2, 1fr);
		grid-template-rows: repeat(3, 1fr);
	}

	${breakpoints.only.tablet} {
		grid-template-columns: repeat(2, 1fr);
		grid-template-rows: repeat(3, 1fr);
	}

	${breakpoints.only.mobile} {
		grid-template-columns: 1fr;
		grid-template-rows: repeat(6, 1fr);
		row-gap: 16px;
	}

	${breakpoints.only.xSmMobile} {
		padding: 32px 20px;
	}
`;
export const CurtainsKindContainer = styled.a`
	display: flex;
	flex-direction: column;
	background-color: var(--background-secondary);
	border-radius: 8px;

	&:hover {
		cursor: pointer;
	}
`;
export const CurtainsKindModal = styled.div`
	position: absolute;

	&:empty {
		display: none;
	}
`;
export const CurtainsKindText = styled.div`
	display: flex;
	align-items: center;
	height: 58px;
`;
export const CurtainsKindTextChevron = styled.div`
	margin: 4px 0 0 4px;
`;
export const pictureStyles = css`
	min-height: 240px;
`;
export const imgStyles = css`
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 8px;
`;
